<template>
  <div>
    <div class="duplicates-grid head mb-4">
      <div>{{$t('accounting')}}</div>
      <div>{{$t('date')}}</div>
      <div>{{$t('operation')}}</div>
      <div>{{$t('currency')}}</div>
      <div class="text-right">{{$t('sum')}}</div>
      <div>{{$t('comment')}}</div>
    </div>
    <DuplicateListItem v-for="(deal,i) in duplicates" :key="i"
                       class="duplicates-grid mb-4"
                       :deal="deal"
                       @toggle="$emit('toggle',i)"/>
  </div>
</template>

<script>
import DuplicateListItem
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep2/DuplicateList/DuplicateListItem";

export default {
  name: "DuplicateList",
  components: {DuplicateListItem},
  props: {
    duplicates: {
      type: Array
    }
  },
  i18n:{
    messages:{
      en:{
        accounting: 'Accounting',
        date: 'Date',
        operation: 'Operation',
        currency: 'Currency',
        sum: 'Sum',
        comment: 'Comment',
      },
      ru:{
        accounting:'Учёт операции',
        date:'Дата',
        operation:'Операция',
        currency:'Валюта',
        sum:'Сумма',
        comment:'Комментарий',
      }
    }
  }
}
</script>

<style lang="scss">
.duplicates-grid {
  display: grid;
  align-items: center;
  grid-template-columns: 13.2% 9.6% 17.5% 8% 16.4% auto;
  grid-column-gap: 5px;

  > div {
    @apply px-4;
  }

  &.head > div {
    @apply bg-border text-text-ternary rounded text-sm py-3 px-4;
  }
}
</style>